import { useEffect, useState } from 'react';
import { Descriptions, message } from 'antd';
import { userClassPlan } from '@/services/athena';
import styles from './index.less';

const LessonPlan = (props) => {
  const { tenantId } = props;
  const [classPlan, setClassPlan] = useState({});

  useEffect(() => {
    initClassPlan();
  }, [tenantId]);

  const initClassPlan = () => {
    if (!tenantId) {
      return;
    }
    userClassPlan({ requestData: { tenantId } }).then((res) => {
      if (res.code !== '00000') {
        message.error(res.msg);
        return;
      }
      setClassPlan(res.data);
    });
  };

  const getNum = (num) => (num || num === 0 ? num : '--');

  return (
    <div className={styles.tabContainer}>
      <div className={styles.tabTitle}>课程计划</div>
      <Descriptions
        className={styles.container}
        bordered
        column={2}
        labelStyle={{ width: 400 }}
      >
        <Descriptions.Item label="专属计划">
          {getNum(classPlan.planNum)}
        </Descriptions.Item>
        <Descriptions.Item label="特色课程">
          {getNum(classPlan.courseNum)}
        </Descriptions.Item>
        <Descriptions.Item label="一起练课程数">
          {getNum(classPlan.togetherNum)}
        </Descriptions.Item>
        <Descriptions.Item label="自定义动作数">
          {getNum(classPlan.actionNum)}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default LessonPlan;
